<div *ngIf="showSplash"
     class="app-splash-screen"
     [ngStyle]="{ left: windowWidth,
                  opacity: opacityChange,
                  transition: splashTransition
     }">
  <div class="app-splash-inner">
    <img class="blink-image" src="assets/images/intelis_white_horizontal.png" alt="Intelis Logo">
<!--    <span class="text">-->
<!--      Setting up your account-->
<!--    </span>-->
  </div>
</div>
